import { AnnotationLabel } from './AnnotationLabel'
import type { ExtrapolatedGraphAnnotation } from './types'

type PointAnnotation = ExtrapolatedGraphAnnotation & {
  isHighestVisible: boolean
}

type PointMarkerCircleProps = {
  cx: number
  cy: number
  r?: number
  fill?: string
  stroke?: string
  strokeWidth?: number
  fillOpacity?: number
  defaultFill: string
  defaultR: number
  filter?: string
  // Stacking within the graph container. The line canvas paints at z-index 1,
  // so pass 2+ to keep a marker on top of the line (e.g. the current-point
  // dot at the solid→dashed transition).
  zIndex?: number
  annotation?: PointAnnotation
  backgroundColor?: string
}

export const PointMarkerCircle = ({
  cx, cy, r, fill, stroke, strokeWidth, fillOpacity,
  defaultFill, defaultR, filter, zIndex,
  annotation,
  backgroundColor = '#fffff8',
}: PointMarkerCircleProps) => {
  const resolvedR = r ?? defaultR
  const diameter = resolvedR * 2
  return (
    <>
      <div
        className="absolute rounded-full pointer-events-none"
        style={{
          left: cx,
          top: cy,
          width: diameter,
          height: diameter,
          transform: 'translate(-50%, -50%)',
          backgroundColor: fill ?? defaultFill,
          ...(stroke ? {
            border: `${1.9}px solid ${stroke}`,
            boxSizing: 'content-box',
          } : {}),
          opacity: fillOpacity,
          filter,
          zIndex,
        }}
      />
      {annotation && (
        <AnnotationLabel
          annotation={annotation}
          backgroundColor={backgroundColor}
          isHighestVisible={annotation.isHighestVisible}
        />
      )}
    </>
  )
}
